import { FC, SVGProps } from 'react';

const BotIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({ color = '#fff', size = 20, ...props }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M7.25708 5.87561H12.7423C14.6594 5.87561 15.8525 7.22894 15.8525 9.14415V12.1951C15.8525 14.1104 14.6594 15.4637 12.7414 15.4637H7.25708C5.34002 15.4637 4.14697 14.1104 4.14697 12.1951V9.14415C4.14697 7.22894 5.34548 5.87561 7.25708 5.87561Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.177 2.75258C11.177 2.10232 10.6496 1.57593 10.0003 1.57593C9.35009 1.57593 8.82275 2.10232 8.82275 2.75258C8.82275 3.40283 9.35 3.92922 10.0002 3.92922C10.6496 3.92922 11.177 3.40283 11.177 2.75258Z"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path d="M10 5.87584V3.93054" stroke={color} stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
      <path
        d="M7.89551 9.20697V9.1991"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.103 9.20697V9.1991"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M8.71045 12.2484H11.2896"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M6.29785 18.4253C7.17761 17.9153 8.51361 17.5865 10.0018 17.5865C11.4899 17.5865 12.8177 17.9153 13.6974 18.4253"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M17.9999 9.29785V11.8962M2 9.29785V11.8962"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default BotIcon;
